import { createContext, use } from 'react';

export const StatusInitialLoadingContext = createContext<(() => void) | null>(
  null,
);

export const useMarkStatusInitialLoadingReady = () => {
  const markStatusInitialLoadingReady = use(StatusInitialLoadingContext);

  if (!markStatusInitialLoadingReady) {
    throw new Error(
      'useMarkStatusInitialLoadingReady must be used within StatusInitialLoadingShellProvider',
    );
  }

  return markStatusInitialLoadingReady;
};
